import React from "react";
import { Route, useRouteMatch } from "react-router-dom";
import Invoices from "../invoices/Invoices";
import Dashboard from "../../../features/dashboard";
import CouponsPage from "../../../features/coupons";
import Orderadd from "../Orderadd";
import PaymentLinksPage from "../../../features/paymentLinks";
import OrderAddManually from "./order/OrderAddManually";
import VendaBalcaoPage from "../pos/VendaBalcaoPage";
import Profile from "../Profile";
import AdminProductList from "../AdminProductList";
import Settings from "../Settings";
import Collaboration from "../Collaboration";
import Profileedit from "../Profileedit";
import CreateProduct from "../Product/Create";
import StocksPage from "../Stocks/StocksPage";
import StockDetailPage from "../Stocks/StockDetailPage";
import {
  GoogleIntegrationPage,
  FacebookIntegrationPage,
  TikTokIntegrationPage,
} from "../../../features/integrations";
import { BlingIntegrationPage } from "../../../features/bling";
import Costs from "../../Costs/Costs";
import BulkPricing from "../../Costs/BulkPricing";
import ReviewsPage from "../../../features/reviews";
import StockCount from "../StockCount/StockCount";
import CampanhasPage from "../marketing/CampanhasPage";
import AtendimentoPage from "../atendimento/AtendimentoPage";

export default function AdminDashboard() {
  const { url } = useRouteMatch();
  return (
    <>
      <Route path={`${url}/Dashboard`} component={Dashboard} />
      <Route path={`${url}/Invoices`} component={Invoices} />
      <Route path={`${url}/Profile`} component={Profile} />
      <Route path={`${url}/Profileedit`} component={Profileedit} />
      <Route path={`${url}/Collaboration`} component={Collaboration} />
      <Route path={`${url}/Settings`} component={Settings} />
      <Route path={`${url}/Product`} component={AdminProductList} />
      <Route path={`${url}/product-create/:id?`} component={CreateProduct} />
      <Route path={`${url}/coupon-add`} component={CouponsPage} />
      <Route path={`${url}/order-add`} component={Orderadd} />
      <Route exact path={`${url}/payment-links`} component={PaymentLinksPage} />
      <Route
        path={`${url}/payment-links/novo`}
        render={() => <VendaBalcaoPage mode="link" />}
      />
      <Route
        path={`${url}/order-add-manually`}
        render={() => <VendaBalcaoPage mode="manual" />}
      />
      <Route
        exact
        path={`${url}/venda-balcao`}
        render={() => <VendaBalcaoPage mode="balcao" />}
      />
      <Route
        path={`${url}/venda-balcao/editar/:id`}
        render={(routeProps) => (
          <VendaBalcaoPage
            mode="balcao"
            editOrderId={routeProps.match.params.id}
            editOrderData={routeProps.location.state?.order}
          />
        )}
      />
      <Route path={`${url}/Stocks`} component={StocksPage} />
      <Route
        path={`${url}/EditOrInsertVariantStocks/:id`}
        component={StockDetailPage}
      />
      <Route
        path={`${url}/GoogleIntegration`}
        component={GoogleIntegrationPage}
      />
      <Route
        path={`${url}/FacebookIntegration`}
        component={FacebookIntegrationPage}
      />
      <Route
        path={`${url}/TikTokIntegration`}
        component={TikTokIntegrationPage}
      />
      <Route path={`${url}/BlingIntegration`} component={BlingIntegrationPage} />
      <Route path={`${url}/costs`} component={Costs} />
      <Route path={`${url}/bulk-pricing`} component={BulkPricing} />
      <Route path={`${url}/reviews`} component={ReviewsPage} />
      <Route path={`${url}/StockCount`} component={StockCount} />
      <Route path={`${url}/marketing-campanhas`} component={CampanhasPage} />
      <Route
        path={`${url}/atendimento-conversas`}
        component={AtendimentoPage}
      />
    </>
  );
}
